"use strict";
/* eslint-disable @typescript-eslint/no-restricted-types, @typescript-eslint/no-unsafe-function-type */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Injector = void 0;
// TODO: This is shallow class and we could just export result of `NestFactory.create(InternalApiModule)`
// from a file and use where this is used and in main.ts
class Injector {
    static setModuleRef(ref) {
        Injector.moduleRef = ref;
    }
    static get(type) {
        return Injector.moduleRef.get(type);
    }
}
exports.Injector = Injector;
